module.exports = __webpack_public_path__ + "img/pdf.55bf9357.svg";